// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "textarea[data-v-91120d76]{width:100%;border:0;outline:0;outline-offset:0;font-size:14px;font-size:clamp(14px,3.86vw,20px);line-height:17px;line-height:1.2;letter-spacing:.38px;resize:none;overflow:hidden;height:21px;background:none}.bold[data-v-91120d76]{font-family:SFProDisplay-Medium,sans-serif}", ""]);
// Exports
module.exports = exports;
